import agent from 'superagent';

const requests = {};
const TIMEOUT = 10000;

export const STATUS = {
    NOT_FOUND: 404,
    TIMEOUT: 408,
    FORBIDDEN: 403,
    ERROR: 500,
};

/*
 * API request, with opt-in request key
 * Supplying a key will cause in-flight requests of the
 * same key to be cancelled.
 *
 * This is the desired behaviour for things like autocomplete,
 * where user interaction can cause multiple API requests, but the
 * user is only interested in the results for the latest one
 */
export default function request(method, url, key = null) {
    const req = agent(method, url)
        .timeout(TIMEOUT)
        .type('application/json');

    // monkey-patch SuperAgent instance to include
    // key we use for cancelling conflicting requests
    req.requestKey = key;
    return req;
}

export function get(path, key = null) {
    return request('GET', path, key);
}

export function post(path, key = null) {
    return request('POST', path, key).type('form');
}

export function put(path, key = null) {
    return request('PUT', path, key).type('form');
}

export function resolve(req) {
    if (req.requestKey) {
        registerRequest(req);
    }

    return new Promise((accept, reject) => {
        req.end((err, res) => {
            if (err) {
                if (err.timeout === TIMEOUT) {
                    return reject(new Error('API timeout'));
                }

                return reject(err);
            }

            // superagent doesn't auto-parse hal+json
            if (res.type === 'application/hal+json') {
                res.body = JSON.parse(res.text);
            }

            // TODO: more thorough HTTP code coverage
            if (res.status === 403) {
                reject(new Error('Forbidden response from API'));
            } else if (!res.ok) {
                reject(new Error('API returned bad response'));
            } else {
                accept(res.body);
            }
        });
    });
}

export function pendingRequestKeys() {
    return Object.keys(requests);
}

function registerRequest(req) {
    const key = req.requestKey;
    if (!key) {
        return;
    }
    if (requests.hasOwnProperty(key)) {
        requests[key].abort();
    }
    requests[key] = req;
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/api/request.js